export const SMS_MESSAGE_MAX_LENGTH = 160;
export const DEFAULT_MESSAGE_MAX_LENGTH = 512;

export function messageMaxLengthForChannels(channels) {
  return (channels ?? []).includes('text') ? SMS_MESSAGE_MAX_LENGTH : DEFAULT_MESSAGE_MAX_LENGTH;
}
